export const siteName = "抖漫";

export const navLinks = [
  { label: "热门榜单", href: "#ranking" },
  { label: "最新更新", href: "#updates" },
  { label: "作品库", href: "#library" },
  { label: "题材导航", href: "#genres" },
  { label: "精选推荐", href: "#featured" },
  { label: "追更指南", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];

export const heroStats = [
  { value: "12,860+", label: "收录作品" },
  { value: "380+", label: "每日更新章节" },
  { value: "92 万", label: "日活跃读者" },
  { value: "7", label: "大型题材分类" },
];

export const hotRanking = [
  { rank: 1, title: "回归者的学院生活", category: "韩漫", hot: "98.2", trend: "new", note: "本周冲榜新作，连续 5 天登顶" },
  { rank: 2, title: "长安十二时", category: "国漫", hot: "96.7", trend: "up", note: "完结后热度不减，长篇口碑佳作" },
  { rank: 3, title: "财阀家的小女儿", category: "韩漫", hot: "95.4", trend: "flat", note: "完结 3 天仍稳居前三" },
  { rank: 4, title: "怪物猎人日志", category: "韩漫", hot: "93.1", trend: "up", note: "战斗分镜广受好评" },
  { rank: 5, title: "猫之邮局", category: "动漫", hot: "92.6", trend: "down", note: "治愈系常青作品" },
  { rank: 6, title: "龙脉守护者", category: "国漫", hot: "91.8", trend: "up", note: "玄幻热度持续走高" },
  { rank: 7, title: "山海关夜行", category: "国漫", hot: "90.3", trend: "flat", note: "国风志怪人气稳定" },
  { rank: 8, title: "与恶龙的契约", category: "韩漫", hot: "89.5", trend: "up", note: "恋爱奇幻题材黑马" },
  { rank: 9, title: "星海列车", category: "动漫", hot: "88.9", trend: "new", note: "上线两周进入前十" },
  { rank: 10, title: "御剑行", category: "国漫", hot: "87.6", trend: "down", note: "仙侠长篇稳定更新" },
];

export const latestUpdates = [
  { title: "外卖侠的日常", category: "国漫", chapter: "第 205 话", time: "1 小时前" },
  { title: "回归者的学院生活", category: "韩漫", chapter: "第 128 话", time: "2 小时前" },
  { title: "深夜拉面屋", category: "动漫", chapter: "第 158 话", time: "3 小时前" },
  { title: "山海关夜行", category: "国漫", chapter: "第 143 话", time: "4 小时前" },
  { title: "怪物猎人日志", category: "韩漫", chapter: "第 94 话", time: "5 小时前" },
  { title: "御剑行", category: "国漫", chapter: "第 117 话", time: "6 小时前" },
  { title: "龙脉守护者", category: "国漫", chapter: "第 132 话", time: "7 小时前" },
  { title: "与恶龙的契约", category: "韩漫", chapter: "第 61 话", time: "8 小时前" },
  { title: "星海列车", category: "动漫", chapter: "第 52 话", time: "9 小时前" },
  { title: "都市灵能事务所", category: "国漫", chapter: "第 97 话", time: "10 小时前" },
];

export const genreTags = [
  "奇幻",
  "都市",
  "恋爱",
  "悬疑",
  "热血",
  "治愈",
  "校园",
  "玄幻",
  "科幻",
  "搞笑",
  "日常",
  "仙侠",
  "武侠",
  "历史",
  "末世",
  "美食",
];

export const guideSteps = [
  {
    step: "01",
    title: "先看榜单，快速锁定热门",
    desc: "首页的热门榜单按实时热度排序，每天更新。想跟大部队一起追，就从榜单前三名开始。",
    icon: "ri-fire-line",
  },
  {
    step: "02",
    title: "再看更新，跟上连载进度",
    desc: "最新更新区列出各作品刚发布的章节与更新时间，标注「连载中」的作品会在这里持续出现新话。",
    icon: "ri-history-line",
  },
  {
    step: "03",
    title: "用作品库筛选，找到对味的那本",
    desc: "在作品库里按韩漫 / 国漫 / 动漫切换，再叠加题材标签或搜索关键词，几秒就能缩小到想看的范围。",
    icon: "ri-filter-3-line",
  },
  {
    step: "04",
    title: "收藏想追的，等待完结再补",
    desc: "偏好一口气看完的读者，可以在作品库里只看「已完结」的作品；追更党则关注连载中的章节更新节奏。",
    icon: "ri-bookmark-3-line",
  },
];

export const faqs = [
  {
    q: "抖漫这里看漫画是免费的吗？",
    a: "是的。抖漫是一个免费在线观看的漫画聚合入口，页面内的作品与更新信息都可以直接浏览。我们不设置付费墙，具体的可看范围以作品页面的更新状态为准。",
  },
  {
    q: "韩漫、国漫、动漫有什么区别，怎么选？",
    a: "本站按来源把作品分为韩漫、国漫、动漫三类。韩漫多为长条连载、节奏偏都市与恋爱；国漫常见玄幻、仙侠与历史题材；动漫则以治愈、日常与剧情向作品为主。三者都可在作品库里随时切换浏览。",
  },
  {
    q: "最新漫画章节多久更新一次？",
    a: "更新节奏由各作品自身的排期决定。首页的「最新更新」区会按发布时间倒序展示最近发布的章节，方便你判断作品是否仍在稳定连载中。",
  },
  {
    q: "热门榜单是怎么排出来的？",
    a: "榜单综合了近期阅读量、收藏变化与更新活跃度，每天刷新一次。榜内会标注热度值与趋势（新上榜 / 上升 / 持平 / 下降），仅供参考，不代表唯一标准。",
  },
  {
    q: "可以用关键词搜索想看的作品吗？",
    a: "可以。作品库顶部提供关键词搜索，支持按作品名、作者或题材词匹配，搜索结果只作用于本站已经收录的作品，不会跳转到外部页面。",
  },
  {
    q: "冷门佳作在哪里找？",
    a: "除了热门榜单，本站专门整理了「冷门佳作」板块，收录热度不高但口碑扎实的作品。想避开同质化、寻找新鲜题材的读者可以从那里入手。",
  },
];

export const discoverFinished = [
  { title: "财阀家的小女儿", category: "韩漫", length: "全 210 话", reason: "豪门群像完整收束，结局口碑极高" },
  { title: "长安十二时", category: "国漫", length: "全 168 话", reason: "一日查案，长篇悬疑一气呵成" },
  { title: "猫之邮局", category: "动漫", length: "全 96 话", reason: "单元治愈短篇，适合睡前慢慢读" },
];

export const discoverHidden = [
  { title: "雪国来客", category: "动漫", length: "连载 44 话", reason: "篇幅不长，氛围与伏笔都很讲究" },
  { title: "都市灵能事务所", category: "国漫", length: "连载 97 话", reason: "灵异 + 轻喜剧，节奏轻松不累" },
  { title: "废土拾荒人", category: "国漫", length: "连载 88 话", reason: "末世设定扎实，世界观慢热耐看" },
];